import type {AssetGalleryAsset} from '@netx/core-asset-gallery/types';
import type {IAsset} from '@netx/core-asset-next/schema';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {
	assetPermissionChecker,
	PermissionName,
	PermissionMatrixName,
} from '@netx/core-permissions-next';
import {assetExpirationEnabled} from './assetExpirationEnabled';

export const canModifyAssetExpiration = (
	asset?: AssetGalleryAsset | IAsset,
): boolean => {
	if (!asset) return false;
	if (!assetExpirationEnabled()) return false;
	if (!currentUserMeetsUserLevel(UserLevel.MANAGER)) return false;
	return assetPermissionChecker({
		asset,
		permissionMatrixName: PermissionMatrixName.DELETE,
		permissionName: PermissionName.EXPIRE,
	});
};
